// This file is auto-generated by the "tsproxygen.exe" tool. Manual modification is not recommended.
import { makeServiceRequest } from "../ServiceRequest";
import type RequestOptions from "../RequestOptions";
import type SetMailboxCalendarConfigurationRequest from "../contract/SetMailboxCalendarConfigurationRequest";
import type OptionsResponseBase from "../contract/OptionsResponseBase";
import setMailboxCalendarConfigurationRequest from "../factory/setMailboxCalendarConfigurationRequest";

export default function setMailboxCalendarConfigurationOperation(req: SetMailboxCalendarConfigurationRequest, options?: RequestOptions): Promise<OptionsResponseBase> {
    if (req !== undefined && !req["__type"]) {
        req = setMailboxCalendarConfigurationRequest(req);
    }
    
    return makeServiceRequest<OptionsResponseBase>("SetMailboxCalendarConfiguration", req, options);
}
